export default __webpack_public_path__ + "static/media/metricas.d0da6195.svg";